export default __webpack_public_path__ + "static/media/property_1_16.cba66587.webp";